import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { debounceTime } from 'rxjs/operators';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { CommonService } from 'src/app/shared/utils/common.service';
import { resetForm, Utility } from 'src/app/shared/utils/utility.service';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import { IUser } from '../../user-management-interfaces';
import { UserManagementService } from '../../user-management.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { UserTypeRequest } from 'src/app/shared/constants/request-mapping';
import { userTypeResponse } from 'src/app/shared/constants/response-mapping';
import { AddUserService } from '../add-user.service';
import { UserCards } from 'src/app/shared-layout/Components/activity/user-card.interface';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from 'src/app/shared/state-management/state-interfaces';
import { DashboardManagementService } from 'src/app/dashboard/dashboard-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
})
export class VerifyEmailComponent implements OnInit, OnDestroy {
  private readonly searchSubject$ = new Subject<string | undefined>();
  dashboardList!: UserCards;
  dashboardSubscription: Subscription | undefined;
  subscription: Subscription | undefined;

  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Input() isLoading!: boolean;
  @Output() stepperChange = new EventEmitter<number>();
  @ViewChild('verifyEmail', { static: false }) verifyEmail:
    | ElementRef
    | undefined;

  currentUser!: IUser | undefined;
  @Output() currentUserEmitter = new EventEmitter<IUser | undefined>();

  @ViewChild('csvReader') csvReader: any;
  formGroup!: FormGroup;
  AccessEmailformGroup!: FormGroup;
  AccessTimeformGroup!: FormGroup;
  BuildingListingformGroup!: FormGroup;
  UserDetailformGroup!: FormGroup;
  UserTypeformGroup!: FormGroup;
  submited = false;
  siteId!: string;
  sharedData?: ISharedData;
  shareedDataSubscription?: Subscription;
  currentAlphabet: string | undefined;
  userList$!: Observable<IUser[] | undefined>;
  isUserSearch: boolean = false;
  searchKeyPress: boolean = false;
  selectedUserPanel: boolean = false;
  userSearch: string = '';
  loader: boolean = false;
  profileImageSrc: string = 'assets/svg/ico-user-with-gray-circle.svg';
  @Input() skipStepUserType: boolean = false;
  @Output() skipStepUserTypeChange = new EventEmitter<boolean>();
  profileImageLoader: string = CONSTANTS.PROFILE_IMAGE_LOADER;
  @Input() skipStepBuilding: boolean = false;
  @Output() skipStepBuildingChange = new EventEmitter<boolean>();

  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  isFlag = new BehaviorSubject<boolean>(false);
  constructor(
    public rootFormGroup: FormGroupDirective,
    public commonService: CommonService,
    private userManagementService: UserManagementService,
    private sharedDataService: SharedDataService,
    private helperService: HelperService,
    private notificationService: NotificationService,
    private elementRef: ElementRef,
    private addUserService: AddUserService,
    private ngRedux: NgRedux<IAppState>,
    private dashboardManagementService: DashboardManagementService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {
    this.subscription = this.ngRedux
      .select('dashboardActivities')
      .subscribe((dashboardActivity: any) => {
        if (
          JSON.stringify(this.dashboardList) !==
          JSON.stringify(dashboardActivity)
        ) {
          this.dashboardList = dashboardActivity;
        }
      });
  }

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.dashboardSubscription =
      this.commonService.getDashboardStatisticsSubject.subscribe(
        (siteId: string) => {
          if (siteId) {
            this.getDashboardStatistics(siteId);
            this.commonService.setDashboardStatistics('');
          }
        }
      );

    this.shareedDataSubscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
        const currentSiteId = this.sharedData?.selectedSite?.siteId;
        if (currentSiteId && currentSiteId !== this.siteId) {
          this.siteId = String(currentSiteId);
        }
      }
    );
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.AccessEmailformGroup = this.rootFormGroup.control.get(
      'accessEmail'
    ) as FormGroup;
    this.AccessTimeformGroup = this.rootFormGroup.control.get(
      'accessTime'
    ) as FormGroup;
    this.BuildingListingformGroup = this.rootFormGroup.control.get(
      'buildingList'
    ) as FormGroup;
    this.UserDetailformGroup = this.rootFormGroup.control.get(
      'userDetails'
    ) as FormGroup;
    this.UserTypeformGroup = this.rootFormGroup.control.get(
      'userTypes'
    ) as FormGroup;
    this.searchSubject$
      .pipe(debounceTime(500))
      .subscribe((searchQuery: any) => {
        this.loader = true;
        // update when api integrate
        this.userList$ = this.userManagementService.getUsersBySite(
          this.siteId,
          searchQuery,
          CONSTANTS.GET_USERS_BY_SITES_OPERATION_UPDATE,
          true,
          10000,
          true
        );
      });
  }

  /**
   * @description get dashobard statistic
   * @param siteId
   * @returns void
   */
  getDashboardStatistics(siteId: string): void {
    this.dashboardManagementService.getDashboardStatistics(siteId).subscribe();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper += -1));
  }

  /**
   * @description patch the reactive form control by the given string value
   * @param firstName control name
   * @param lastName control name
   */
  updateForm(firstName: string, lastName: string, existingUserId: string) {
    this.formGroup?.patchValue({
      existingUserId: existingUserId,
    });
  }

  /**
   * @description validate form if form valid hold value into main form and redirect to next step
   * @returns void
   */
  submit(): void {
    if (!this.isLoading) {
      this.submited = true;
      if (this.formGroup.valid) {
        if (this.formGroup.controls.email.value && !this.selectedUserPanel) {
          this.userManagementService
            .verifyUser(this.formGroup.controls.email.value)
            .subscribe({
              next: (res) => {
                this.AccessTimeformGroup.reset();
                this.resetAccessTimeForm();
                this.addUserService.resetAll();
                if (res?.data?.getUserSummary) {
                  if (res?.data?.getUserSummary?.isDeactivated) {
                    return this.notificationService.showError(
                      this.translate.instant('USER_NOT_FOUND')
                    );
                  }
                  this.currentUser = {
                    userId: this.formGroup.controls.email.value,
                    userType: res?.data?.getUserSummary.userType, //user.userType,
                    name:
                      res?.data?.getUserSummary.firstName +
                      ' ' +
                      res?.data?.getUserSummary.lastName,
                    phoneNumber: res?.data?.getUserSummary.phoneNumber,
                    email: this.formGroup.controls.email.value,
                  };
                  if (res?.data?.getUserSummary.userType) {
                    this.callGetUserAccess(this.formGroup.controls.email.value);
                  } else {
                    this.sendUser(this.currentUser);
                    this.stepperChange.emit((this.stepper += 1));
                  }
                } else if (res?.errors) {
                  this.notificationService.showError(res.errors);
                } else {
                  this.UserDetailformGroup.reset();
                  this.UserDetailformGroup.enable();
                  resetForm(this.AccessEmailformGroup as FormGroup, '');
                  this.BuildingListingformGroup
                    ? resetForm(this.BuildingListingformGroup as FormGroup, '')
                    : null;
                  this.UserTypeformGroup.reset();
                  this.UserTypeformGroup.enable();
                  this.AccessEmailformGroup?.controls?.email?.patchValue(
                    this.formGroup?.controls?.email?.value
                  );
                  this.AccessEmailformGroup.patchValue({
                    region: CONSTANTS.PHONE_NUMBER_REGION,
                  });
                  this.AccessEmailformGroup?.controls.email.disable();
                  this.AccessEmailformGroup?.controls.phone.enable();
                  this.formGroup?.controls.existingUserId.setValue('');
                  this.stepperChange.emit((this.stepper += 1));
                  this.currentUserEmitter.emit(undefined);
                }
              },
              error: (err: Error) => {
                if (window.__dev__) console.log('submitToParent', err);
                this.AccessTimeformGroup.reset();
                this.resetAccessTimeForm();
                this.addUserService.resetAll();
                this.notificationService.showError(err.message);
              },
            });
        } else if (this.selectedUserPanel) {
          this.stepperChange.emit((this.stepper += 1));
        }
      }
    }
  }
  @HostListener('document:keydown.enter')
  onEnterKeyDown(): void {
    const verifyEmail =
      this.elementRef.nativeElement.querySelector('#verifyEmail');
    if (verifyEmail) {
      verifyEmail.focus();
    }
  }

  resetAccessTimeForm(): void {
    this.AccessTimeformGroup.patchValue({
      repeat: false,
    });
    this.AccessTimeformGroup.removeControl('repeatStartTime');
    this.AccessTimeformGroup.removeControl('repeatEndTime');
    this.AccessTimeformGroup.removeControl('repeatDays');
  }

  callGetUserAccess(email: string) {
    this.userManagementService
      .getUserAccess(this.sharedData?.selectedSite?.siteId, email)
      .subscribe({
        next: (getUserAccess: any) => {
          this.currentUser!.groupIds = getUserAccess?.userGroups || [];
          this.currentUser!.unitsAndAccessPoints =
            getUserAccess?.unitsAndAccessPoints;
          if (this.currentUser) {
            this.sendUser(this.currentUser);
            this.stepperChange.emit((this.stepper += 1));
          }
        },
        error: (err: Error) => {
          if (window.__dev__) console.log('getUserAccess', err);
          this.notificationService.showError(err.message);
        },
      });
  }

  /**
   * @description check alphabet is coming from first time and return first character of it
   * @param name {string}
   * @param index {number}
   * @returns return boolean state
   */
  checkIfNew(name: string, index: number): boolean {
    index === 0 ? (this.currentAlphabet = '') : null;
    if (this.currentAlphabet === name?.charAt(0).toLowerCase()) return false;
    this.currentAlphabet = name?.charAt(0).toLowerCase();
    return true;
  }

  /**
   * @param data encode string
   * @returns return encode data
   */
  encode(data: string): string {
    return Utility.encodeToBase64(data);
  }

  /**
   * @description search user if character greater than 0
   * @returns void
   */
  searchUser(): void {
    if (this.userSearch.length > 0) {
      this.searchKeyPress = true;
      this.selectedUserPanel = false;
      this.currentUser = {} as IUser as IUser;
      this.userList$ = of(undefined);
      resetForm(this.formGroup);
      this.searchSubject$.next(this.userSearch);
    } else {
      this.searchKeyPress = false;
      this.userList$ = of(undefined);
    }
  }

  /**
   * @description get selected user object
   * @param {user} user object
   * @returns void
   */
  selectUser(user: IUser): void {
    if (user?.assignedPartnerId) {
      this.notificationService.showError(
        this.translate.instant('USER_NOT_AVAILABLE')
      );
    } else {
      this.resetAccessTimeForm();
      this.skipStepUserTypeChange.emit((this.skipStepUserType = true));
      if (
        user.userType === CONSTANTS.PROPERTY_MANAGER_ADMIN ||
        user.userType === CONSTANTS.PROPERTY_MANAGER_USER
      ) {
        this.callGetUserAccess(user.userId);
      } else {
        this.skipStepBuildingChange.emit((this.skipStepBuilding = false));
        this.userManagementService
          .getUserAccess(
            this.sharedData?.selectedSite?.siteId,
            user?.email || ''
          )
          .subscribe({
            next: (getUserAccess: any) => {
              this.currentUser = {
                userId: user.userId,
                userType: user.userType,
                name: user.name,
                phoneNumber: user.phoneNumber,
                email: user.email,
                userImgUrl: user.userImgUrl,
              };
              this.currentUser!.groupIds = getUserAccess?.userGroups || [];
              this.currentUser!.unitsAndAccessPoints =
                getUserAccess?.unitsAndAccessPoints;

              this.userSearch = '';
              this.searchKeyPress = true;
              this.selectedUserPanel = true;
              this.updateForm(user.name!, '', user.email!);
              if (this.currentUser) {
                this.sendUser(this.currentUser);
                this.currentUserEmitter.emit(this.currentUser);
                this.stepperChange.emit((this.stepper += 1));
              }
            },
            error: (err: Error) => {
              if (window.__dev__) console.log('submitToParent', err);

              this.notificationService.showError(err.message);
            },
          });
      }
    }
  }

  /**
   * @description send  user object
   * @param {user} user object
   * @returns void
   */
  sendUser(user: IUser): void {
    this.skipStepUserTypeChange.emit((this.skipStepUserType = true));
    if (
      user.userType === UserTypeRequest[CONSTANTS.PROPERTY_MANAGER_ADMIN] ||
      user.userType === UserTypeRequest[CONSTANTS.PROPERTY_MANAGER_USER]
    ) {
      this.skipStepBuildingChange.emit((this.skipStepBuilding = true));
    } else {
      this.skipStepBuildingChange.emit((this.skipStepBuilding = false));
    }
    // update when api integrate
    this.currentUser = {
      userId: user.userId,
      userType: user.userType, //user.userType,
      name: user.name,
      phoneNumber: user.phoneNumber,
      email: user.email,
      groupIds: user.groupIds,
      unitsAndAccessPoints: user.unitsAndAccessPoints,
    };

    this.updateForm(user.name!, '', user.email!);
    this.currentUserEmitter.emit(this.currentUser);
  }
  /**
   * @description selected user remove and reset all variables
   * @returns void
   */
  removeUser(): void {
    this.skipStepUserTypeChange.emit((this.skipStepUserType = false));
    this.searchKeyPress = false;
    this.selectedUserPanel = false;
    this.userSearch = '';
    this.currentUser = {} as IUser as IUser;
    this.userList$ = of(undefined);
    resetForm(this.formGroup);

    this.formGroup.controls.email.setValidators(
      MFValidators.compose([MFValidators.required, MFValidators.email])
    );

    this.formGroup.updateValueAndValidity();
    // Pass undefined because method expected groupId key
    // this.currentUserEmitter.emit(undefined);
  }
  flagReset() {
    this.isFlag.next(false);
  }
  /**
   * @description angular hook all onces when component leave, and unsubcribe all subcribtions
   * @returns void
   */
  ngOnDestroy(): void {
    this.shareedDataSubscription?.unsubscribe();
  }

  isFrench(): boolean {
    return this.translate.currentLang === 'fr-ca';
  }
}
